import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const PLAN_LABELS = {
  free: '무료',
  basic: '베이직',
  premium: '프리미엄',
} as const

export const FREE_BETA = import.meta.env.VITE_PILOT_FREE_BETA !== 'false'
